/**
 * Dashboard Home Page
 */

export function DashboardHome() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-[#2F353D] mb-4">Dashboard</h1>
      <p className="text-gray-600">Welcome to DuneWorks</p>
    </div>
  );
}
